import Vue from 'vue'
import Contact from './Contact.vue'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, { ak: '4jB3lrv8GxupTvIf5ivnt6h8HF3i1QvV' })

import AnimateCss from 'animate.css';
Vue.use(AnimateCss);

import api from '../../../request/api' // 自定义全局请求
Vue.prototype.$api = api;

import '../../../assets/font/myFont.css'

import '../../../assets/css/vue2editor.css'

new Vue({
    render: h => h(Contact),
}).$mount('#contact')